import React, { useState } from "react";
import { Link } from "react-router-dom";

/* Portrait 9:16 share card for Instagram Stories / TikTok / phone screenshots.
 Also renders fine as full-page on desktop. */

const TAGLINES = [
 { key: "cage", hero: "STOP TALKING", sub: "GET IN THE CAGE.",
 story: "The new standard for online rap battles. All ages. All skill levels." },
 { key: "say", hero: "IF YOU GOT", sub: "SOMETHING TO SAY —",
 story: "This is where you say it. AI opponents. Real vocals. Live judging." },
 { key: "stage", hero: "TOO SHY FOR", sub: "THE STAGE?",
 story: "You're not too shy for the cage. Step up. youngtongues.com" },
 { key: "real", hero: "REAL. RAW.", sub: "COMPETITION.",
 story: "The dopest rap battle site just hit the net. This is the real deal." },
];

export default function Share() {
 const [tagKey, setTagKey] = useState("cage");
 const tag = TAGLINES.find(t => t.key === tagKey) || TAGLINES[0];
 const qrUrl = "https://api.qrserver.com/v1/create-qr-code/?size=280x280&bgcolor=000000&color=FFD700&data=https%3A%2F%2Fyoungtongues.com";

 const ANNOUNCEMENT = `Yo — the dopest site just hit the net.

If you got something to say, this is where you say it. youngtongues.com is the new standard for the online rap battle scene. This is real, raw competition for everybody — all ages, all skill levels.

If you're too shy to hit the stage but you're not too shy to stand in this cage, this is your platform.

This is the real deal. Stop talking about it and get in the cage.

Battle here: youngtongues.com`;

 const SHORT_HOOK = `The dopest rap battle site just hit the net. AI opponents. Real vocals. Live judging. Stop talking about it and get in the cage. youngtongues.com`;

 const [copiedKey, setCopiedKey] = useState(null);
 const copy = (text, key) => {
 try {
 navigator.clipboard.writeText(text);
 setCopiedKey(key);
 setTimeout(() => setCopiedKey(null), 2500);
 } catch { /* clipboard blocked */ }
 };

 return (
 <div className="bg-black text-white">
 {/* Tagline picker — hide when screenshotting */}
 <div data-screenshot-hide className="max-w-6xl mx-auto px-6 py-6 print:hidden">
 <div className="font-mono text-xs tracking-widest text-yt-muted mb-2">
 PICK A TAGLINE THEN SCREENSHOT THE CARD BELOW
 </div>
 <div className="flex flex-wrap gap-2">
 {TAGLINES.map(t => (
 <button key={t.key} data-testid={`tagline-${t.key}`} onClick={() => setTagKey(t.key)}
 className={`px-3 py-2 border font-mono text-xs tracking-widest ${
 tagKey === t.key ? "border-yt-yellow bg-yt-yellow text-black" : "border-yt-border hover:border-yt-yellow"
 }`}>
 {t.hero.slice(0, 12).toUpperCase()}
 </button>
 ))}
 </div>
 <div className="mt-3 font-mono text-[10px] text-yt-muted">
 Phone screenshot: portrait card below. Desktop: right-click card → save image.
 </div>
 </div>

 {/* ========== THE SHARE CARD (screenshot this) ========== */}
 <div data-testid="share-card" className="mx-auto shadow-2xl relative overflow-hidden bg-black"
 style={{ width: "min(100vw, 480px)", aspectRatio: "9 / 16" }}>
 {/* Background arena splash */}
 <img src="/arenas/nyc-rooftop.png" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
 <div className="absolute inset-0 bg-gradient-to-b from-black via-black/50 to-black" />

 {/* Grid overlay for texture */}
 <div className="absolute inset-0 opacity-10"
 style={{ backgroundImage: "linear-gradient(rgba(255,215,0,0.4) 1px,transparent 1px),linear-gradient(90deg,rgba(255,215,0,0.4) 1px,transparent 1px)", backgroundSize: "40px 40px" }} />

 <div className="relative h-full flex flex-col justify-between p-8">
 {/* Top: brand */}
 <div>
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-red animate-pulse-red">
 LIVE · AI RAP BATTLE PLATFORM
 </div>
 <div className="font-display leading-none mt-3">
 <div className="text-5xl md:text-6xl text-yt-yellow tracking-tight">YOUNG</div>
 <div className="text-5xl md:text-6xl text-yt-red tracking-tight">TONGUES</div>
 </div>
 <div className="font-mono text-[10px] tracking-[0.3em] text-yt-muted mt-2">
 RIPPEN RAP BATTLES
 </div>
 </div>

 {/* Middle: killer tagline */}
 <div className="text-center py-4">
 <div className="font-display text-4xl md:text-5xl leading-tight tracking-tight text-white">
 {tag.hero}
 </div>
 <div className="font-display text-4xl md:text-5xl leading-tight tracking-tight text-yt-yellow mt-1">
 {tag.sub}
 </div>
 <div className="font-mono text-sm text-yt-muted mt-6 max-w-xs mx-auto leading-relaxed">
 {tag.story}
 </div>
 </div>

 {/* Middle features strip */}
 <div className="grid grid-cols-3 gap-2 text-center border-t border-b border-yt-border py-3">
 <div>
 <div className="text-2xl"></div>
 <div className="font-mono text-[9px] tracking-widest text-yt-yellow mt-1">REAL VOCALS</div>
 </div>
 <div>
 <div className="text-2xl"></div>
 <div className="font-mono text-[9px] tracking-widest text-yt-yellow mt-1">AI JUDGE</div>
 </div>
 <div>
 <div className="text-2xl"></div>
 <div className="font-mono text-[9px] tracking-widest text-yt-yellow mt-1">MONTHLY CROWN</div>
 </div>
 </div>

 {/* Bottom: URL + QR */}
 <div className="flex items-end justify-between gap-4">
 <div className="flex-1">
 <div className="font-mono text-[10px] tracking-[0.4em] text-yt-muted">STEP IN THE ARENA</div>
 <div className="font-display text-2xl md:text-3xl text-yt-yellow leading-none mt-1">youngtongues</div>
 <div className="font-display text-2xl md:text-3xl text-yt-yellow leading-none">.com</div>
 <div className="mt-3 inline-block bg-yt-red text-white font-display text-sm tracking-wider px-3 py-1.5 shadow-brutal">
 ▶ ENTER THE CYPHER
 </div>
 </div>
 <div className="bg-black p-2 border-2 border-yt-yellow">
 <img src={qrUrl} alt="QR to youngtongues.com" width={110} height={110} className="block" />
 <div className="font-mono text-[8px] text-yt-yellow tracking-widest text-center mt-1">SCAN</div>
 </div>
 </div>
 </div>

 {/* Corner brand tick */}
 <div className="absolute top-3 right-3 font-mono text-[9px] tracking-widest text-white/50 bg-black/60 px-2 py-1">
 © YOUNG TONGUES
 </div>
 </div>

 {/* Copy-paste announcement blocks */}
 <div data-screenshot-hide className="max-w-3xl mx-auto px-6 py-8 print:hidden space-y-4">
 <div className="font-mono text-xs tracking-[0.4em] text-yt-red mb-2"> GRAB THE HOOK — ONE TAP COPY</div>

 <div className="border-2 border-yt-yellow bg-yt-surface p-5">
 <div className="flex justify-between items-start mb-3 gap-3">
 <div>
 <div className="font-display text-lg tracking-tight">FULL ANNOUNCEMENT</div>
 <div className="font-mono text-[10px] text-yt-muted">Send this to group chats, Facebook, Reddit, email blasts</div>
 </div>
 <button data-testid="copy-full-btn" onClick={() => copy(ANNOUNCEMENT, "full")}
 className={`px-4 py-2 font-mono text-xs tracking-widest border transition-colors ${
 copiedKey === "full" ? "bg-yt-judge text-black border-yt-judge" : "bg-yt-yellow text-black border-yt-yellow hover:bg-yt-red hover:text-white hover:border-yt-red"
 }`}>
 {copiedKey === "full" ? "✓ COPIED" : "COPY"}
 </button>
 </div>
 <pre className="font-mono text-sm text-white whitespace-pre-wrap leading-relaxed bg-black p-4 border border-yt-border">{ANNOUNCEMENT}</pre>
 </div>

 <div className="border-2 border-yt-red bg-yt-surface p-5">
 <div className="flex justify-between items-start mb-3 gap-3">
 <div>
 <div className="font-display text-lg tracking-tight">SHORT HOOK</div>
 <div className="font-mono text-[10px] text-yt-muted">For Twitter/X, TikTok captions, YouTube comments — 200 chars</div>
 </div>
 <button data-testid="copy-short-btn" onClick={() => copy(SHORT_HOOK, "short")}
 className={`px-4 py-2 font-mono text-xs tracking-widest border transition-colors ${
 copiedKey === "short" ? "bg-yt-judge text-black border-yt-judge" : "bg-yt-red text-white border-yt-red hover:bg-yt-yellow hover:text-black hover:border-yt-yellow"
 }`}>
 {copiedKey === "short" ? "✓ COPIED" : "COPY"}
 </button>
 </div>
 <pre className="font-mono text-sm text-white whitespace-pre-wrap leading-relaxed bg-black p-4 border border-yt-border">{SHORT_HOOK}</pre>
 </div>

 <div className="border border-yt-border bg-yt-surface p-5">
 <div className="flex justify-between items-start mb-3 gap-3">
 <div>
 <div className="font-display text-lg tracking-tight">JUST THE LINK</div>
 <div className="font-mono text-[10px] text-yt-muted">Drop into comment sections, DMs, wherever</div>
 </div>
 <button data-testid="copy-link-btn" onClick={() => copy("https://youngtongues.com", "link")}
 className={`px-4 py-2 font-mono text-xs tracking-widest border transition-colors ${
 copiedKey === "link" ? "bg-yt-judge text-black border-yt-judge" : "border-yt-border hover:border-yt-yellow hover:text-yt-yellow"
 }`}>
 {copiedKey === "link" ? "✓ COPIED" : "COPY"}
 </button>
 </div>
 <div className="font-mono text-yt-yellow text-lg">https://youngtongues.com</div>
 </div>
 </div>

 {/* How-to-share section — hide when screenshotting */}
 <div data-screenshot-hide className="max-w-3xl mx-auto px-6 py-10 print:hidden">
 <div className="font-mono text-xs tracking-[0.4em] text-yt-red mb-2"> HOW TO BLAST THIS OUT</div>
 <h2 className="font-display text-3xl tracking-tight mb-6">GET YOUNG TONGUES IN FRONT OF PEOPLE</h2>

 <div className="space-y-4">
 <ShareStep n="1" title="Screenshot the card above">
 Phone: iPhone → press power + volume up together · Android → power + volume down. Crop to just the card.
 </ShareStep>
 <ShareStep n="2" title="Text it to 20 friends and family">
 Attach the image + message: &quot;Yo — just launched my rap battle site. AI opponents, AI judge. Come rap: youngtongues.com&quot;
 </ShareStep>
 <ShareStep n="3" title="Post to any group chat / Discord / Facebook">
 The image + link speaks for itself. Zero explanation needed.
 </ShareStep>
 <ShareStep n="4" title="Drop in YouTube comments on rap battle videos">
 Find a battle rap YouTube video (KOTD, URL, etc.) — post: &quot;For anyone who wants to test their bars against AI: youngtongues.com — real judge that scores flow / rhyme / punchlines&quot;
 </ShareStep>
 <ShareStep n="5" title="Reddit — r/rap, r/hiphopheads, r/battlerap">
 Use the SHORT HOOK from above. &quot;The dopest rap battle site just hit the net. AI opponents. Real vocals. Live judging. Stop talking about it and get in the cage. youngtongues.com&quot;
 </ShareStep>
 </div>

 <div className="mt-10">
 <Link to="/cypher" data-testid="share-goto-cypher"
 className="inline-block bg-yt-red text-white font-display text-lg tracking-wider px-6 py-3 shadow-brutal hover:bg-yt-yellow hover:text-black">
 MAKE A CYPHER VIDEO NEXT →
 </Link>
 </div>
 </div>
 </div>
 );
}

function ShareStep({ n, title, children }) {
 return (
 <div className="flex gap-4 border border-yt-border bg-yt-surface p-4">
 <div className="font-display text-3xl text-yt-yellow leading-none">{n}</div>
 <div>
 <div className="font-display text-lg tracking-tight">{title}</div>
 <div className="font-mono text-sm text-yt-muted mt-1 leading-relaxed">{children}</div>
 </div>
 </div>
 );
}
